import { SELENIUM } from "src/app/components/library/common/library.constants";
import { IExcelOptions } from "../interface/auto-generate.interface";
import { ITabConfig } from "../interface/tab.interface";
export const EQUALSIGNERROR = 'equalSignError';
export const DELETE_DISABLED_TOOLTIP = 'You cannot delete the Test Case because you are not the owner';
export const COMMON_POPUP = {

  DELETE_TEST_CASE_TS: {
    TITLE: 'Delete Test Case',
    MESSAGE: `Are you sure you want to delete the Test Case?`
  },
  
  Steps: {
    TITLE: 'Delete Application Step',
    MESSAGE: 'Are you sure you want to delete this Application Step?',
  },
  Bots: {
    TITLE: 'Delete Bot',
    MESSAGE: 'Are you sure you want to delete this Bot?',
  },
  linkedUserStories: {
    TITLE: 'De-link User Story',
    MESSAGE: 'Are you sure you want to delink this user story?',
  },
  linkedDevObjects: {
    TITLE: 'Delink Dev Object',
    MESSAGE: 'Are you sure you want to delink this dev object?',
  },
  applicationFields: {
    TITLE: 'Delete Application Field',
    MESSAGE: 'Are you sure you want to delete this application field?',
  },
  'Test Cases': {
    TITLE: 'Delete Test Case',
    MESSAGE: 'Are you sure you want to delete this Test Case? ',
    WARNING: `It will disappear from {scenariocount} Test Scenarios. Connections will be missed in scenarios where it was used.`,
  },
  DOWNLOAD_ALL_TESTS_WITH_WARNING:{
    TITLE: 'Download All Tests',
    MESSAGE:'You are about to download all Tests in this project? Please click Continue to confirm. The download process may take some time.',
    WARNING: 'The project has unmapped Test Cases and Test Scenarios. These Test Cases and Test Scenarios will not be included in the download file.',
  },
  'Test Scenarios': {
    TITLE: 'Delete Test Scenario',
    MESSAGE: 'Are you sure you want to delete this Test Scenario?',
  },
  'Add Test Case': {
    TITLE: 'Add Test Case',
    MESSAGE: 'Are you sure you want to add this Test Case?',
  },
  'Leave Test Case': {
    TITLE: 'Leave a Test Case',
    MESSAGE: `Are you sure you want to leave this page?
        New Test Case was not saved. All data input will be lost upon leaving.`,
  },
  leave: {
    TITLE: 'Leave a Test Case',
    MESSAGE: `Are you sure you want to leave this page?
        Test Case was not saved. All data input will be lost upon leaving.`,
  },
  'Leave Test Scenario Settings': {
    TITLE: 'Leave a Test Scenario',
    MESSAGE: `Are you sure you want to leave this page?
        Test Scenario data was not saved. All data input will be lost upon leaving.`
  },
  'Cancel Add Test Case': {
    TITLE: 'Cancel adding a new Test Case',
    MESSAGE: `Are you sure you want to cancel adding a new Test Case?
        New Test Case was not saved. All data input will be lost upon cancelling.`,
  },
  'Cancel Edit Test Case': {
    TITLE: 'Cancel editing a Test Case',
    MESSAGE: `Are you sure you want to cancel editing a Test Case?
        Edit changes of Test Case were not saved. All data input will be lost upon cancelling.`,
  },
  'Cancel Duplicate Test Case': {
    TITLE: 'Cancel duplicating a Test Case',
    MESSAGE: `Are you sure you want to cancel duplicating a Test Case?
         changes of Test Case were not saved. All data input will be lost upon cancelling.`,
  },
  'Unmap Test Case': {
    TITLE: 'Unmap Test Case',
    MESSAGE: `If you remove this Test Case Assignment, it will be moved to the Unmapped Test Cases section. Do you want to proceed?`,
  },

  'app versions': {
    TITLE: 'Delete Application Version',
    MESSAGE: `Are you sure you want to delete this application version? Once deleted, all data cannot be recovered.`,
  },
  release: {
    TITLE: 'Delete Release',
    MESSAGE: `Are you sure you want to delete this release?`,
  },
  cycle: {
    TITLE: 'Delete Cycle',
    MESSAGE: `Are you sure you want to delete this cycle?`,
  },
  'Add user': {
    TITLE: 'Add Users',
    MESSAGE: `Are you sure you want to add these users?`,
  },
  'Update user': {
    TITLE: 'Edit User details',
    MESSAGE: `Are you sure you want to edit this user?`,
  },
  'Delete user': {
    TITLE: 'Delete User?',
    MESSAGE: `Are you sure you want to delete this user?`,
  },
  'Leave Test Scenario': {
    TITLE: 'Leave a Test Scenario Canvas',
    MESSAGE: `Are you sure you want to leave this page?
        New test scenario was not saved. All data input will be lost upon leaving.`,
  },
  'manage teams': {
    TITLE: 'Delete Team',
    MESSAGE: `Are you sure you want to delete this Team?`,
  },
  'delete bot': {
    TITLE: 'Delete Bot',
    MESSAGE: `Are you sure you want to delete bot? All nested elements (pages/sections, sub-pages/sections and objects) will be removed along with the bot.`,
  },
  'delete dictionary': {
    TITLE: 'Delete Dictionary',
    MESSAGE: `Are you sure you want to delete dictionary?`,
  },
  'import': {
    TITLE: 'Import Data from Golden Dictionary in Library',
    MESSAGE: `The Project Dictionary will be updated with the latest information from the Golden Dictionary.`,
  },
  'Delete Settings': {
    TITLE: 'Delete Settings',
    MESSAGE: `Are you sure you want to delete this Settings?`,
  },
  'Delete Test Suite': {
    TITLE: 'Delete Test Suite',
    MESSAGE: `Are you sure you want to delete this Test Suite?`,
  },
  'disable ALM integration': {
    TITLE: 'ALM Integration disabling',
    MESSAGE: `Are you sure you want to disable the ALM integration?`,
  },
  'disable qTest integration': {
    TITLE: 'Tricentis qTest Integration disabling',
    MESSAGE: `Are you sure you want to disable the Tricentis qTest integration?`,
  },
  'disable SAP CALM integration':{
    TITLE: 'SAP CALM Integration disabling',
    MESSAGE: `Are you sure you want to disable the SAP CALM integration?`,
  },
  'Critical_Path': {
    TITLE: 'Change Critical path',
    ALTERNATE_MESSGAE: `Are you sure you want to change <b>{projectName}</b> (from Core <b>to Alternative</b>) Critical path?
    When replacing this indicator, the structure of taxonomy nestings will change. The structure of the taxonomy will change as follows: L1 > L2 > L3 > User Story > Test Cases.`,
    CORE_MESSGAE: `Are you sure you want to change <b>{projectName}</b> (from Alternative <b>to Core</b>) Critical path?
    When replacing this indicator, the structure of taxonomy nestings will change. The structure of the taxonomy will change as follows: L1 > L2 > L3 > L4 > Test Cases.`
  },
  'Gen_AI': {
    TITLE: 'Connecting with Gen AI',
    ENABLE_MESSAGE: `Are you sure you want to change <b>{projectName}</b> (from Disable <b>to Enable</b>) connecting with Gen AI?`,
    DISABLE_MESSAGE: `Are you sure you want to change <b>{projectName}</b> (from Enable <b>to Disable</b>) connecting with Gen AI?`,
  },

  'TEST_AI_EXECUTION_AGENT': {
    TITLE: `{toAction} Test AI Execution Agent`,
    ENABLE_MESSAGE: `After enabling the TestAI Execution Agent, the orchestrator settings parameters will not be editable and can only be updated from the Agent. Please enter the Agent Key and confirm enabling the TestAI Execution Agent if you agree.`,
    DISABLE_MESSAGE: `After disabling the TestAI Execution Agent, the orchestrator settings parameters will be editable. In order to confirm your intention, enter the word <b>DISABLE</b> in the field below in capslock.`
  },

  'EDIT_AGENT_KEY': {
    TITLE: 'Agent Key',
    MESSAGE: `Edit agent key for <strong>{projectName}</strong> project.`,
  },

  'DELETE_GEN_AI_TEST_CASES': {
    TITLE: 'Delete Gen AI Testcases',
    MESSAGE: `Are you sure you want to Delete Gen AI Testcases for <b>{projectName}</b>.`,
  },

  IMPORT_FROMLIBRARY:{
    TITLE: 'Leave',
    MESSAGE:'Are you sure want to close the \'Import from Library\' panel without saving and updating the Taxonomy and Application Version?'
  },

  IMPORT_CONFIRMATION:{
    TITLE: 'Import Confirmation',
    MESSAGE:'<b>Warning:</b> Proceeding will permanently delete all current application steps for test cases and import new steps from the Library. This action cannot be undone. Do you want to continue ?'
  },

  SELECTIVE_DOWNLOAD:{
    TITLE: 'Leave',
    MESSAGE:'Are you sure want to discard the selection and close \'Download Panel\'? Please click on Continue to confirm.',
    SUCCESS_MSG : "The file with Tests in Test AI format has been downloaded to your device successfully.",
    START_MSG : "Download in Test AI format has started and may take some time.",
    ERROR_MSG : "An unknown error occurred. Please refresh the page and try again",
  },
  
  DOWNLOAD_ALL_TESTS:{
    TITLE: 'Download All Tests',
    MESSAGE:'Are you sure you want to discard the selection and download all Tests in this project? Please click Continue to confirm. The download process may take some time.',
  },

  BACK_POPUP:{
    TITLE: 'Back to Previous Page',
    MESSAGE:'Are you sure you want to go back to the previous page? Any unsaved changes will be lost.',
  },

  SESSION_CHANGE:{
    TITLE: 'Session Change',
    MESSAGE: 'Are you sure you want to change the session? Any unsaved changes will be lost.',
  },

  CHANGE_AGENT_MODE: {
    TITLE: 'Agent Mode Switching',
    MESSAGE: 'Are you sure you want to switch modes? Switching modes will change the interface. Your current progress will be cleared.'
  },

  TITLE: 'Export to ',
  PROJECT: 'Project',
  CONFIRM: 'Confirm',
  DOWNLOAD: 'Download',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
  LEAVE: 'Leave',
  UPDATE: 'Update',
  ADD_CYCLE: 'Test Scenario Cycle',
  CONTINUE: 'Continue',
  ADD_DUPLICATE: 'Add Duplicate',
  DISABLE: 'Disable',
  APPLY: 'Apply',
  FILTER: 'Filter',
  RESET: 'Reset',
  WIDTH: '600px',
  EXPORT_DESCRIPTION: 'Selected Test Scenarios will be exported to Deloitte ALM Project',
  EXPORT_TITLE: 'Export to Deloitte ALM Project',
  SUBTYPE: 'Test Scenarios',
  PROCEED: 'Proceed',

  AGENTIC_VIEW: {
    TITLE: "{toAction} Agentic View",
    MESSAGE: `Are you sure you want to <b>{toAction}</b> Agentic View for <b>{projectName}</b> ?`,
  },

  ASK_ME_CLOSE: {
    TITLE: "Close Test AI Assistant?",
    MESSAGE: `Are you sure you want to Close Test AI Assistant?`,
    INFO: `Your current session will be deleted and any unsaved data will be lost.`,
  },

  ASK_ME_RESET: {
    TITLE: "Reset Session?",
    MESSAGE: `Are you sure you want to reset session?`,
    INFO: `The Current Session data will be lost.`,
  },

  BOT_ATTACHED: {
    TITLE: 'BOT ALREADY ATTACHED',
    MESSAGE: `There is already a bot named {botName} attached to a test case. Do you want to regenerate the bot or continue with the same bot?`,
  },

  DUPLICATE_BOT_NAME: {
    TITLE: 'Bot Name Duplication',
    MESSAGE: `A bot named {botName} already exists. Add it as a duplicate anyway?`,
  },

  BOT_DUPLICATION_POPUP: {
    title: 'Bots with the duplicating names',
    description:
      'The bots below have been added as duplicates because bots with the same names already exist.',
    buttonText: 'Add Duplicates',
    skipBtn: 'Skip Duplicates',
    cancelBtn: 'Cancel',
    size: 'medium'
  },

  AUTOGEN_ALL_TEST_CASES_WARNING: {
    TITLE: "Warning",
    MESSAGE:
      "Proceeding will permanently delete all current application steps for test cases and generate new using GenAI. This action cannot be undone. Do you want to continue ?",
  },

  DELETE_TOOL_SETTINGS: {
    TITLE: "Reset UiPath Settings",
    MESSAGE:
      "This action will reset data in <b>Orchestrator</b>, <b>General</b> and <b>Test Manager</b> tabs. Please confirm that you want to proceed.",
  },
};

export const DELETE_SELECTED_TITLE = 'Delete Selected ';
export const DELETE_APPLICATION_STEP_CONFIRMATION_MSG = 'Are you sure you want to delete Application steps? Once deleted, all data cannot be recovered.';

export const CYCLE = 'cycle';
export const ADD_CANCEL = 'Cancel Add Test Case';
export const EDIT_CANCEL = 'Cancel Edit Test Case';
export const DUPLICATE_CANCEL = 'Cancel Duplicate Test Case';
export const LEAVE = 'Leave Test Case';
export const ADD_SAVE = 'New Test Case Save';
export const BULK_UPDATE = 'Bulk Update';
export const DELETE = 'DELETE';
export const SAVE = 'SAVE';
export const UI_PATH_TOOL = 'UIPATH';
export const TOSCA = 'TOSCA';
export const UI_PATH_TEST_MANAGER_TOOL = 'UIPATH TEST MANAGER';
export const AUTO_GENERATED_SUCCESS_TEXT = 'The Result has been generated';
export const AUTO_GENERATED_FAILED_TEXT = 'Failed to generate result';
export const HIDDEN_COLUMNS = 'Click to view additional properties';
export const COLLAPSE_TABLE = 'Click hide additional properties';
export const CYCLE_BULK_UPDATE_ASSIGNMENT_LABEL = 'Assignment for Test Cases in Test Scenarios';
export const CYCLE_BULK_UPDATE_ASSIGNMENT_DESCRIPTION = 'Assignments are applied at the Test Scenario level. All Test Cases within the selected scenario will inherit the same assignment in this cycle';
export const SIGN_IN = 'Signin';
export const DISABLE_ALM_INTEGRATION = "disable ALM integration";
export const QTEST_INTEGRATION_SUCCESS = 'The qTest tool successfully integrated';
export const QTEST_INTEGRATION_FAILED = 'The qTest tool was not integrated due to incorrect credentials. Please try again.';
export const DISABLE_QTEST_INTEGRATION = "disable qTest integration";
export const INVOKE_XAML_FAILED_TEXT = "Failed to upload Xaml"
export const DISABLE_SAP_INTEGRATION = "disable SAP CALM integration"
export const ENABLE_SAP_INTEGRATION = "SAP CALM integration enabled successfully."
export const DATA_DICT_DISPLAY_COLUMNS = [
  {
    name: 'Object Details',
    values: [
      'Action',
      'Object',
      'Data',
      'TestDataTemplate',
      'TableName',
      'Mandatory Flag',
      'Dynamic Flag',
      'Search Flag',
      'Continue on Fail'
    ],
  },
  {
    name: 'Object Properties',
    values: ['Id', 'Name', 'Aaname', 'Innertext', 'Tag', 'Title', 'Xpath', 'Business Type'],
    windowValues: ['wnd_app', 'wnd_title', 'wnd_aastate', 'wnd_cls'],
  },
  {
    name: 'Additional Object Properties',
    values: [
    ],
  },
];
export const SELENIUM_EXEC_COLUMNS = [
  "Id",
  "Aaname",
  "Innertext",
  "Tag",
  "Xpath",
];
export const LABEL_NAMES = {
  'TestDataTemplate': 'Upload Test Data from Excel',
  'TableName': 'Table Name',
  'Mandatory Flag': 'Mandatory',
  'Dynamic Flag': 'Dynamic Properties',
  'Search Flag': 'Press Enter after adding data',
  'wnd_app': 'App',
  'wnd_title': 'Title',
  'wnd_aastate': 'Aastate',
  'wnd_cls': 'Cls',
}

export const BUSINESS_TYPE = [
  "Button",
  "CheckBox",
  "ComboBox",
  "Image",
  "Label",
  "ListBox",
  "Menu",
  "RadioButton",
  "Slider",
  "TabControl",
  "Table",
  "TextBox",
  "TreeView",
  "Link",
  "Cell",
  "Container",
];

export const EDIT_OBJECT_CSS = {
  'bot': {
    width: '43vw',
    position: {
      top: '3.2rem',
      right: '0',
    }
  },
  'auto': {
    width: '43vw',
    position: {
      top: '3vh',
      right: '2.7vw',
    }
  },
  'project': {
    width: '43vw',
    position: {
      top: '10.6rem',
      right: '0',
    }
  }
}

export const COPY_SELECTOR_REGEX= {
  tagNameMatch: /^<(\w+)/,
  attributeFindRegex: /(\w+(-\w+)*)(?:\s*=\s*(['"])(.*?)\3)?/g,
  iframTag: 'IFRAME',
  findTag:/<[^>]+>/g
}
export const ACTION_OPTIONS = [
  'Click',
  'Enter',
  'Select',
  'Simulate Click',
  'Simulate Type',
  'Get Text',
  'Get Number',
  'Verify Object Exists',
  'Verify Object Attribute',
  'Copy Bot',
  'Link Bot',
  'Verify Text',
  'Double Click'
];
export const OBJECT_DETAILS = {
  ACTION : 'Action',
  DATA : 'Data',
  TEST_DATA_TEMPLATE :'TestDataTemplate',
}
export const TOKEN_LIMIT_ERROR = 'Token Limit Excceeded.';
export const SESSION_EXP_MSG = 'Session Expired.Try generating again!';
export const STOP = 'Stop';
export const SESSION_NOT_EXIST_MSG = 'No such session exists';
export const RESET_BUTTON_MSG = 'Delete The Tool Settings';
export const RADIO_IMG_PATH = {
  selected: 'assets/images/selectedRadio.svg',
  nonSelected: 'assets/images/nonSelectedRadio.svg',
};
export const TEST_CASE_UPDATED_MSG = 'Test case updated successfully';
export const ADD_BOT_DESCRIPTION =
  'The selected bots will be added to the current bot on the page/section. Choose the addition method: Link Bot or Copy Bot Items.';
export const DOWNLOAD_EXECUTION_HISTORY_POPUP_DATA = {
  TITLE: 'Download Data',
  GEN_MESSAGE:
    'Downloading the execution history for all bots in the project may take some time. The data will be generated into file(s) before downloading.<br>To begin the process for creating the file(s), click on Generate button. Once the data is ready, please return to download the file(s).',
  DOWNLOAD_MESSAGE:
    'Files were last generated on <b>{time}</b>. The download may take some time. To include the latest executions, click Regenerate.',
};
export const OPTIONS: IExcelOptions[] = [
  {
    name: 'Import Bot',
    image: 'assets/images/importbot.svg',
    selected: false,
  },
  {
    name: 'Import Application Steps',
    image: 'assets/images/applicationSteps.svg',
    selected: false,
  },
];
export const TOOLS: IExcelOptions[] = [
  {
    name: UI_PATH_TOOL,
    image: 'assets/images/UIPathIntegration.svg',
    selected: false,
  },
  {
    name: SELENIUM,
    image: 'assets/images/selenium.svg',
    selected: false,
  },
  {
    name: TOSCA,
    image: 'assets/images/tool-logos/tosca-logo.svg',
    selected: false,
  },
];
export const KEYBOARD_ACTIONS : string[] = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  'Back',
  'Tab',
  'NumEnter',
  'Enter',
  'Break',
  'Pause',
  'Caps',
  'Esc',
  'PgUp',
  'PgDn',
  'End',
  'Home',
  'Left',
  'Up',
  'Right',
  'Down',
  'Ins',
  'Del',
  'LWin',
  'RWin',
  'Sleep',
  'Num0',
  'Num1',
  'Num2',
  'Num3',
  'Num4',
  'Num5',
  'Num6',
  'Num7',
  'Num8',
  'Num9',
  'Num*',
  'Num+',
  'Num-',
  'Num/',
  'Decimal',
  'F1',
  'F2',
  'F3',
  'F4',
  'F5',
  'F6',
  'F7',
  'F8',
  'F9',
  'F10',
  'F11',
  'F12',
  'Num',
  'Scroll',
  'LShift',
  'RShift',
  'LCtrl',
  'RCtrl',
  'LAlt',
  'RAlt',
  'Comma',
  'Minus',
  'Oem1',
  'Oem2',
  'Oem3',
  'Oem4',
  'Oem5',
  'Oem6',
  'Oem7',
  'Oem8',
];
export const MODIFIERS : string [] =[
  'Alt',
  'Ctrl',
  'Shift',
  'Ctrl+Shift',
  'Ctrl+Alt',
  'Alt+Shift',
  'Ctrl+Alt+Shift'
]
export const TOSCA_ACTIONS: string[] = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  'Back',
  'Tab',
  'Enter',
  'Caps',
  'Esc',
  'PgUp',
  'PgDn',
  'End',
  'Home',
  'Delete',
  'Up',
  'Down',
  'Left',
  'Right',
  'Ins',
  'Del',
  'Num0',
  'Num1',
  'Num2',
  'Num3',
  'Num4',
  'Num5',
  'Num6',
  'Num7',
  'Num8',
  'Num9',
  'Num*',
  'Num+',
  'Num-',
  'Num/',
  'F1',
  'F2',
  'F3',
  'F4',
  'F5',
  'F6',
  'F7',
  'F8',
  'F9',
  'F10',
  'F11',
  'F12',
  'F13',
  'F14',
  'F15',
  'F16',
  'Break',
  'Print Screen',
  'Scroll lock',
  'Num lock',
  'Help',
];
export const EDIT_OBJECT = "Edit Object Information";
export const EDIT_PROMPT = "Edit Prompt / Code";
export const VIEW_PROMPT = "View Prompt / Code";
export const EDIT_CUSTOM_CODE_TAB_DETAILS: ITabConfig[] = [
  { label: EDIT_OBJECT },
  { label: EDIT_PROMPT },
];
export const FILTERED = 'Filtered';
export const ALL = 'All';